import ContentAdvancedView from './ContentAdvancedView'

export default ContentAdvancedView
